/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum tagTargetScopeEnum {
    USER = 'user',
    GLOBAL = 'global',
    TEAM = 'team',
}